import { useMemo } from 'react';
import {
  useDeleteConditionGroupLookupMutation,
  ConditionGroupLookup,
} from '../api';
import { ConditionGroupAction } from '../table-config';
import { useEntityActions } from '@hooks/useEntityActions';

// Define getEntityId outside to ensure stability
const getEntityId = (group: ConditionGroupLookup) => group.id;

// Define additional actions config outside hook for stability
const ADDITIONAL_ACTIONS = {
  manageConditions: 'conditions', // Maps to navigateToModal(id, 'conditions')
};

export const useConditionGroupActions = () => {

  const actions = useEntityActions<ConditionGroupLookup, ConditionGroupAction>({
    entityName: 'Condition Group',
    displayProperty: 'name',
    deleteMutation: useDeleteConditionGroupLookupMutation,
    getEntityId,
    additionalActions: ADDITIONAL_ACTIONS,
  });

  return useMemo(() => actions, [actions]);
}; 